export default __webpack_public_path__ + "static/media/marker-blue-sky.262ec6bc.png";